import { render, staticRenderFns } from "./MediaFilePreview.vue?vue&type=template&id=d2895552&"
import script from "./MediaFilePreview.vue?vue&type=script&lang=js&"
export * from "./MediaFilePreview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/digital-seaside/sst-admin-panel/webapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d2895552')) {
      api.createRecord('d2895552', component.options)
    } else {
      api.reload('d2895552', component.options)
    }
    module.hot.accept("./MediaFilePreview.vue?vue&type=template&id=d2895552&", function () {
      api.rerender('d2895552', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/media-file-preview/MediaFilePreview.vue"
export default component.exports